import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-idle-timeout-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="idle-overlay" *ngIf="visible">
      <div class="idle-dialog">
        <div class="idle-icon">
          <i class="ti ti-clock-pause"></i>
        </div>
        <h4>{{ isArabic ? 'هل ما زلت هنا؟' : 'Are you still here?' }}</h4>
        <p>{{ isArabic
          ? 'لم يتم رصد أي نشاط لمدة 30 دقيقة. سيتم تسجيل خروجك تلقائياً خلال:'
          : 'No activity detected for 30 minutes. You will be logged out in:' }}</p>
        <div class="countdown">{{ formattedTime }}</div>
        <div class="idle-actions">
          <button class="btn btn-primary" (click)="onContinue.emit()">
            {{ isArabic ? 'نعم، أريد الاستمرار' : 'Yes, continue' }}
          </button>
          <button class="btn btn-outline-danger" (click)="onLogout.emit()">
            {{ isArabic ? 'تسجيل الخروج' : 'Logout' }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .idle-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      backdrop-filter: blur(4px);
    }

    .idle-dialog {
      background: #fff;
      border-radius: 16px;
      padding: 40px 36px;
      text-align: center;
      max-width: 420px;
      width: 90%;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
      animation: slideIn 0.3s ease-out;
    }

    @keyframes slideIn {
      from {
        opacity: 0;
        transform: scale(0.9) translateY(-20px);
      }
      to {
        opacity: 1;
        transform: scale(1) translateY(0);
      }
    }

    .idle-icon {
      margin-bottom: 16px;
    }

    .idle-icon i {
      font-size: 56px;
      color: #f59e0b;
    }

    h4 {
      margin: 0 0 8px;
      font-size: 22px;
      font-weight: 700;
      color: #1e293b;
    }

    p {
      margin: 0 0 20px;
      font-size: 14px;
      color: #64748b;
      line-height: 1.6;
    }

    .countdown {
      font-size: 36px;
      font-weight: 700;
      color: #ef4444;
      margin-bottom: 24px;
      font-variant-numeric: tabular-nums;
    }

    .idle-actions {
      display: flex;
      gap: 12px;
      justify-content: center;
    }

    .idle-actions .btn {
      min-width: 140px;
      padding: 10px 24px;
      font-size: 15px;
      border-radius: 10px;
      font-weight: 600;
    }
  `]
})
export class IdleTimeoutDialogComponent implements OnInit, OnDestroy {
  @Input() visible = false;
  @Output() onContinue = new EventEmitter<void>();
  @Output() onLogout = new EventEmitter<void>();

  remainingSeconds = 5 * 60; // 5 دقائق
  formattedTime = '05:00';
  isArabic = false;

  private countdownInterval: any = null;

  ngOnInit(): void {
    this.isArabic = document.documentElement.lang === 'ar' ||
      document.documentElement.dir === 'rtl' ||
      localStorage.getItem('language') === 'ar';
  }

  ngOnChanges(): void {
    if (this.visible) {
      this.startCountdown();
    } else {
      this.stopCountdown();
    }
  }

  ngOnDestroy(): void {
    this.stopCountdown();
  }

  private startCountdown(): void {
    this.remainingSeconds = 5 * 60;
    this.updateDisplay();
    this.stopCountdown();

    this.countdownInterval = setInterval(() => {
      this.remainingSeconds--;
      this.updateDisplay();
      if (this.remainingSeconds <= 0) {
        this.stopCountdown();
      }
    }, 1000);
  }

  private stopCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  private updateDisplay(): void {
    const mins = Math.floor(this.remainingSeconds / 60);
    const secs = this.remainingSeconds % 60;
    this.formattedTime = `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
}
